import React, { useContext, useEffect, useState } from 'react';
import { OrderReviewContext } from '../../OrderReviewContext';
import DefaultFlatFormHeader from './DefaultFlatFormHeader';
import DefaultNestedFormHeader from './DefaultNestedFormHeader';

export const DefaultFormHeader = ({
  formDefinitions,
  saveAnswersAsync,
  removeAnswersAsync,
  editPropertyCharacteristics,
}) => {
  // #region STATE
  /**
   * the nested layout is used when the QA Layout table 
   * is utilized.  This layout table causes some form defs 
   * to be `required` and therefore that is how we can 
   * check if we should use the nested layout renderer
   */
  const [useNestedLayout, setUseNestedLayout] = useState(false);
  // #endregion STATE

  // #region HOOKS
  // #endregion HOOKS

  // #region COMPUTED
  // #endregion COMPUTED

  // #region FUNCTIONS
  // #endregion FUNCTIONS

  // #region EFFECTS
  useEffect(() => {
    const requiredFormDefsCount = formDefinitions.filter(fd => fd.required).length;
    const shouldUseNestedLayout = requiredFormDefsCount > 0;
    setUseNestedLayout(shouldUseNestedLayout);
  }, [formDefinitions]);
  // #endregion EFFECTS

  return useNestedLayout ? (
    <DefaultNestedFormHeader
      formDefinitions={formDefinitions}
      saveAnswersAsync={saveAnswersAsync}
      removeAnswersAsync={removeAnswersAsync}
      editPropertyCharacteristics={editPropertyCharacteristics}
    />
  ) : (
    <DefaultFlatFormHeader
      formDefinitions={formDefinitions}
      saveAnswersAsync={saveAnswersAsync}
      removeAnswersAsync={removeAnswersAsync}
      editPropertyCharacteristics={editPropertyCharacteristics}
    />
  );
};
